import { useCallback, useContext, useSyncExternalStore } from 'react'
import { UNSAFE_DataRouterContext } from 'react-router-dom'

export function useSidenavRouteSelector(selector: (pathname: string) => boolean): boolean {
  const context = useContext(UNSAFE_DataRouterContext)
  if (!context) throw new Error('Sidenav navigation requires RouterProvider')
  const { router } = context
  const subscribe = useCallback((notify: () => void) => router.subscribe(notify), [router])
  // Boolean snapshots only re-render items whose active status actually changed.
  const getSnapshot = useCallback(
    () => selector(router.state.navigation.location?.pathname ?? router.state.location.pathname),
    [router, selector]
  )
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}
